export default "__VITE_ASSET__Ds6ooOst__"